<template>
    <div v-if="regionCheck()">
        <div class="flex flex-row gap-4 items-center justify-between">
            <div class="w-[50px] h-[50px] text-white shrink-0">
                <img :alt="$translate(abonnement.product.name)" class="w-full h-full object-contain" :src="abonnement.product.image.replace('.png', '-gradient.png')" />
            </div>
            <div class="w-9/12">
                <strong class="text-sm line-clamp-1 text-ellipsis overflow-hidden">
                    {{ $translate(abonnement.product.name) }}
                </strong>
                <small>
                    {{ $translate(getAbonnementPeriod.title) }}
                </small>
                <p class="w-auto underline text-blue cursor-pointer text-xxs" @click="$emit('cancel', abonnement)">
                    {{ $t('terminate_abonnement') }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['abonnement'],
    emits: ['cancel'],
    data: () => ({
        region: window?.meta?.region_configuration.region
    }),
    computed: {
        getAbonnementPeriod() {
            return this.abonnement.productVariant.productAttributeValues.data.find((productAttributeValue) => productAttributeValue.meta.type === 'period');
        },
        getAbonnementFrequency() {
            return this.abonnement.productVariant.productAttributeValues.data.find((productAttributeValue) => productAttributeValue.meta.type === 'frequency');
        },
        background() {
            let backgroundColor = this.abonnement.product.productGroups.data[0].productCategories.data[0].background_color;
            let backgroundGradient = this.abonnement.product.productGroups.data[0].productCategories.data[0].background_gradient;

            return 'linear-gradient(to bottom, ' + backgroundColor + ' 0%, ' + backgroundGradient + ' 100%)';
        }
    },
    methods: {
        regionCheck() {
            return this.region === this.abonnement.region;
        }
    }
};
</script>

<style scoped>
.icon {
    background: v-bind(background);
}
</style>
